import { useState } from "react";
import { GlobalContext } from "./globalContext";

export const GlobalState = (props) => {

    const [loader, setLoader] = useState(false);
    const [loggedIn, setLoggedIn] = useState(sessionStorage.getItem('token') ? true : false);
    const [token, setToken] = useState(sessionStorage.getItem('token'));
    const [email, setEmail] = useState(sessionStorage.getItem('email'));

    const value = {
        loader, setLoader,
        loggedIn, setLoggedIn,
        token, setToken,
        email, setEmail
    }

    return (
        <GlobalContext.Provider value={value}>
            {props.children}
        </GlobalContext.Provider>
    )

}